
import { profileComputed } from "@/state/helpers";
import { authComputed } from "@/state/helpers";

import { defineComponent } from "vue";
import { Route } from "vue-router";

declare interface ComponentData {
  logoImage: string;
}

export default defineComponent({
  data(): ComponentData {
    return {
      logoImage: "",
    };
  },

  computed: {
    ...profileComputed,
    ...authComputed,
    checkMemberLogo(): boolean {
      return (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.logo_pos &&
        this.profilePP.blog.logo_pos.value &&
        this.profilePP.blog.logo_pos.value === "3"
      );
    },

    footerText(): string {
      let name = "YOUR NAME HERE";
      if (
        this.profilePP &&
        this.profilePP.basic &&
        this.profilePP.basic.full_name &&
        this.profilePP.basic.full_name.value
      ) {
        name = this.profilePP.basic.full_name.value;
      }

      return (
        this.$t("footer.privacyText1") +
        name +
        this.$t("footer.privacyText2") +
        name +
        this.$t("footer.privacyText3")
      );
    },

    privacyLink(): Partial<Route> {
      if (this.ppCode) {
        return { name: "privacy-policy", query: { a: this.ppCode } };
      }
      return { name: "privacy-policy" };
    },
  },

  watch: {
    profilePP: {
      handler(): void {
        if (
          this.profilePP &&
          this.profilePP.basic &&
          this.profilePP.basic.logo &&
          this.profilePP.basic.logo.value
        ) {
          this.logoImage = this.profilePP.basic.logo.value;
        }
      },
      deep: true,
    },
  },
});
